import { render, staticRenderFns } from "./error-display.vue?vue&type=template&id=339ace04&scoped=true"
import script from "./error-display.vue?vue&type=script&lang=js"
export * from "./error-display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339ace04",
  null
  
)

export default component.exports